import { render, staticRenderFns } from "./BlockSortObjects.vue?vue&type=template&id=9517e1cc&scoped=true"
import script from "./BlockSortObjects.vue?vue&type=script&lang=js"
export * from "./BlockSortObjects.vue?vue&type=script&lang=js"
import style0 from "./BlockSortObjects.vue?vue&type=style&index=0&id=9517e1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9517e1cc",
  null
  
)

export default component.exports